module.exports = new __parcel__URL__("Design Decision.aea9ef88.svg").toString();